// Mirrors the API's default MAX_FILE_SIZE; if the API is raised later its own message shows instead.
export const MAX_UPLOAD_MB = 15;

const BYTES_PER_MB = 1024 * 1024;

export const UPLOAD_FAILED_MESSAGE = 'Something went wrong. Your ticket was not sent. Please try again.';

/** Size in MB to one decimal, rounded up so a file just over the limit never reads as "10.0". */
export function formatMb(bytes: number): string {
  return (Math.ceil((bytes / BYTES_PER_MB) * 10) / 10).toFixed(1);
}

/** One message per file over the limit; empty when every file fits. */
export function oversizedFileMessages(files: ArrayLike<File> | null): string[] {
  const messages: string[] = [];
  for (const file of Array.from(files ?? [])) {
    if (file.size > MAX_UPLOAD_MB * BYTES_PER_MB) {
      messages.push(`"${file.name}" is ${formatMb(file.size)} MB. Each file must be ${MAX_UPLOAD_MB} MB or smaller.`);
    }
  }
  return messages;
}

/** The API's {"message": ...} from an error, whether or not AuthInterceptor wrapped it as {status: false, error}. */
export function apiErrorMessage(err: any): string {
  const body = err?.status === false ? err?.error?.error : err?.error;
  const message = body?.message;
  return typeof message === 'string' && message.trim() ? message : UPLOAD_FAILED_MESSAGE;
}
